import React from "react";
import Nav from "react-bootstrap/Nav";
import {isBetweenDates} from "../../common/utils";
import Popover from "react-bootstrap/Popover";
import {OverlayTrigger} from "react-bootstrap";

const Item = ({ menu_item, class_name, showHideMenus, is_b2b }) => {
    const header_menu_item_class = menu_item.className ? ' ' + menu_item.className : '';
    if(menu_item.key === 'wholesale' && !is_b2b){
        return null;
    }
    if(menu_item.available_between && !isBetweenDates(menu_item.available_between[0], menu_item.available_between[1])){
        return (
            <OverlayTrigger
                rootClose
                placement={"bottom"}
                trigger={'click'}
                onEnter={() => this.isHidden(false)}
                onExited={() => this.isHidden(true)}
                overlay={
                    <Popover id={`tooltip-wholesale`}>
                        <Popover.Content>
                            {menu_item.tooltip}
                        </Popover.Content>
                    </Popover>
                }
            >
                <Nav.Item
                    className={`${class_name + header_menu_item_class}`}
                    as="button"
                >
                    {menu_item.title}
                </Nav.Item>
            </OverlayTrigger>
        )
    }

    if (menu_item.mouse_over) {
        return (
            <Nav.Item
                className={`${class_name + header_menu_item_class}`}
                onClick={() => {showHideMenus(menu_item.mouse_over, menu_item.mobile_submenu_open_by_default)}}
                as="button"
            >
                {menu_item.title}
                <span className='icon-chevron-right'/>
            </Nav.Item>
        )
    }
    return (
        <Nav.Item
            as="a"
            className={`${class_name + header_menu_item_class}`}
            href={menu_item.href}
        >
            {menu_item.title}
            {menu_item.icon && <span className={`${menu_item.icon} icon`}/>}
        </Nav.Item>
    )
};

export default Item;